'use client'

import { useCallback, useEffect, useState } from 'react'

import { useDropOffPointMapContext } from '@marketplace-web/shipping-services-provider/shipping-services-provider-feature'
import { ConversationLinkActions } from '@marketplace-web/messaging/conversation-messaging-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  getDefaultShippingAddress,
  transformDefaultShippingAddress,
} from '@marketplace-web/address/address-data'

import { clickEvent } from '@marketplace-web/conversation-shipping/conversation-shipping-data'

import DropOffPointModal from '../DropOffPointModal'

const DropOffPointMapLink = () => {
  const { track } = useTracking()
  const { fetchNearbyDropOffPoints } = useDropOffPointMapContext()
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id

  const [isModalOpen, setIsModalOpen] = useState(false)

  const { fetch: fetchDefaultShippingAddress, transformedData: defaultShippingAddress } = useFetch(
    getDefaultShippingAddress,
    transformDefaultShippingAddress,
  )

  useEffect(() => {
    if (!isModalOpen || !defaultShippingAddress) return

    fetchNearbyDropOffPoints({ address: defaultShippingAddress })
  }, [defaultShippingAddress, fetchNearbyDropOffPoints, isModalOpen])

  useEffect(() => {
    if (defaultShippingAddress) return

    if (isModalOpen) fetchDefaultShippingAddress()
  }, [defaultShippingAddress, fetchDefaultShippingAddress, isModalOpen])

  const trackLinkClick = useCallback(() => {
    if (!transactionId) return

    const targetDetails = JSON.stringify({
      transaction_id: transactionId,
    })

    track(
      clickEvent({
        target: 'drop_off_points_map_link',
        targetDetails,
      }),
    )
  }, [track, transactionId])

  const handleClose = () => setIsModalOpen(false)

  const handleModalOpen = useCallback(() => {
    trackLinkClick()
    setIsModalOpen(true)
  }, [trackLinkClick, setIsModalOpen])

  useEffect(() => {
    const handleShipmentLinkClick = event => {
      const element = event.target as HTMLElement

      if (!element.classList.contains(ConversationLinkActions.DropOffPointMapLink)) return

      event.preventDefault()
      handleModalOpen()
    }

    document.body.addEventListener('click', handleShipmentLinkClick)

    return () => {
      document.body.removeEventListener('click', handleShipmentLinkClick)
    }
  }, [handleModalOpen])

  return <DropOffPointModal isOpen={isModalOpen} onClose={handleClose} />
}

export default DropOffPointMapLink
